import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInputFile from "Common/Custom/FormInputFile";


const AddContactInformationForm = ({ 
  fields, 
  values, 
  errors, 
  handleChange, 
  handleSubmit, 
  loading ,
  handleFileChange,
  imagePreview
}) => {
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Add Contact Information</HeadingOne>}
    >
      {fields.map((field) => {

        if (field.type === "file") {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
              imagePreview={imagePreview}
            />
          );
        } 

        return (
        <FormInput
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
        />
        );
        
      })}

      <FormSubmitButton
        label="Add Contact Info"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddContactInformationForm;
